export default __webpack_public_path__ + "static/media/setting-icon.412fa74d.png";